export const DEFAULT_PATHS = {
	public: '/login',
	private: '/stock/inventory-allocations',
} as const;
